"use strict";
/**
 * Setup's income steps, in the words both clients show (BEN-141 FP-010, FP-024).
 *
 * FP-010: a user who removes every income source at the Income step must never
 * be told detection failed. The income was found; they removed it. Every line a
 * later step shows in that state says so instead of "We couldn't spot a regular
 * paycheck".
 *
 * The names end in COPY so the copy inventory (scripts/copy-inventory.mjs) picks
 * the sentences up; they were inventoried as JSX on the setup screens before.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYCHECK_INCOME_REMOVED_COPY = exports.INCOME_REMOVED_COPY = exports.INCOME_ALL_REMOVED_COPY = void 0;
exports.incompleteIncomeHint = incompleteIncomeHint;
/** Under the Income list once every source is removed and nothing is added. */
exports.INCOME_ALL_REMOVED_COPY = "You've removed all your income. Your forecast will be empty until you add a paycheck.";
/** The Income step's subtitle on returning to it after removing every source. */
exports.INCOME_REMOVED_COPY = "You removed your income. Add what you take home and we'll build your budget around it.";
/** The paycheck step's subtitle when the Income step's sources were all removed. */
exports.PAYCHECK_INCOME_REMOVED_COPY = "You removed your income on the Income step. Add the paycheck you want your pay periods built around.";
/**
 * FP-024: the line under the form while an added source has a name and no
 * amount. Such a row is not saved, so the user is told which and what to do.
 */
function incompleteIncomeHint(names) {
    return names.length === 1
        ? `Enter an amount for ${names[0]}, or remove it.`
        : `Enter an amount for ${names.join(", ")}, or remove them.`;
}
//# sourceMappingURL=setupIncomeCopy.js.map